import axios from 'axios';

const API_BASE_URL = '/api/horoscope';

export interface HoroscopeData {
    horoscopes: {
        [key: string]: string;
    };
}

export interface HoroscopeResponse {
    success: boolean;
    data: HoroscopeData;
    date?: string;
    week?: string;
    month?: string;
    year?: number;
    cached?: boolean;
    seo_data?: any;
}

export interface ZodiacSignsResponse {
    success: boolean;
    signs: string[];
    count: number;
}

class HoroscopeService {
    async getDailyHoroscope(language: string = 'english', sign?: string, date?: string): Promise<HoroscopeResponse> {
        const params: any = { language };
        if (sign) params.sign = sign;
        if (date) params.date = date;

        const response = await axios.get(`${API_BASE_URL}/daily`, { params });
        return response.data;
    }

    async getWeeklyHoroscope(language: string = 'english', sign?: string): Promise<HoroscopeResponse> {
        const params: any = { language };
        if (sign) params.sign = sign;

        const response = await axios.get(`${API_BASE_URL}/weekly`, { params });
        return response.data;
    }

    async getMonthlyHoroscope(language: string = 'english', sign?: string, month?: number, year?: number): Promise<HoroscopeResponse> {
        const params: any = { language };
        if (sign) params.sign = sign;
        if (month) params.month = month;
        if (year) params.year = year;

        const response = await axios.get(`${API_BASE_URL}/monthly`, { params });
        return response.data;
    }

    async getYearlyHoroscope(language: string = 'english', sign?: string, year?: number): Promise<HoroscopeResponse> {
        const params: any = { language };
        if (sign) params.sign = sign;
        if (year) params.year = year;

        const response = await axios.get(`${API_BASE_URL}/yearly`, { params });
        return response.data;
    }

    async getZodiacSigns(): Promise<ZodiacSignsResponse> {
        const response = await axios.get(`${API_BASE_URL}/signs`);
        return response.data;
    }
}

export const horoscopeService = new HoroscopeService();
